import { useEffect } from "react";
import { getAuth, Unsubscribe } from "firebase/auth";
import { useDialog } from "app/hook";
import { DialogType } from "app/types";
import { getEnv } from "app/configSlice";
import { parentsFirebase } from "app/Auth";
import parentI18n from "features/parent/i18n";
import { createParentAccount } from "features/user/api";
import { mapLocaleToLanguage } from "./useAuthLocale";

export const useSignUp = () => {
  const handleDialog = useDialog();

  useEffect(() => {
    let unsubscribe: Unsubscribe;

    try {
      const childrenAuth = getAuth();
      const auth = getAuth(parentsFirebase);
      unsubscribe = auth.beforeAuthStateChanged(async (user) => {
        try {
          if (user) {
            if (!user.isAnonymous) {
              let email: string;
              if (
                user.providerData[0].providerId === "google.com" ||
                user.providerData[0].providerId === "apple.com"
              ) {
                email = user.providerData[0].email;
              } else {
                email = user.email;
              }
              await createParentAccount({
                user: {
                  uid: user.uid,
                  child_uid: childrenAuth.currentUser?.uid,
                  email: email,
                  provider: user.providerData[0].providerId,
                  display_name: parentI18n.t("MSG_PARENTS_PROFILE_DEFAULT_NAME"),
                  language: mapLocaleToLanguage(parentI18n.locale),
                  env: getEnv(),
                  timezone: "Asia/Tokyo",
                  country: "ja",
                },
              });
              if (childrenAuth.currentUser?.uid) {
                await childrenAuth.signOut();
              }
            }
          }

          unsubscribe();
        } catch (error) {
          console.error(error);
          unsubscribe();
          handleDialog({ type: DialogType.ERROR_NETWORK, value: true });
        }
      });
    } catch (error) {
      handleDialog({ type: DialogType.ERROR_NETWORK, value: true });
    }
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);
};
